// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-customer-pan-verify-i-otp {
    background-color: rgb(0, 100, 254) !important;
    color: white !important;
    font-size: 14px;
    height: 40px;
    padding: 0;
    border-color: white;
    width: 100%;
    border-radius: 7px;
    /* transform: translateY(15px); */
    float: right;
    margin-top: 35px !important;
  }
  .add-customer-pan-verify-i-scs-otp {
    background-color: rgb(24, 181, 3) !important;
    color: white !important;
    font-size: 14px;
    height: 40px;
    padding: 0;
    width: 100%;
    border-color: white;
    border-radius: 7px;
    /* transform: translateY(15px); */
    float: right;
    margin-top: 35px !important;
  }
  .add-customer-progress-otp {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: 5px !important;
    margin-left: 3px !important;
    color: white !important;
  }
  .pallet-img-gif-background {
    width: 100%;
    height: 100vh;
    background-color: rgb(5, 100, 254) !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .video-background {
    z-index: 1;
    object-fit: contain;
    width: 50vw;
    height: 50vh;
    /* background: rgba(0,0,0,0); */
    /* opacity: 1; */
    /* filter: brightness(50%); */
    /* position: absolute;
    bottom: 5rem;
    left: 0; */
    margin-top: 3rem;
  }
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 0;
    /* position: absolute;
      bottom: 0; */
  }
  .footer-container {
    padding-top: 15rem;
  }
  .message-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100000;
    width: 100vw;
    color: #0868FE;
    font-size: 4em;
    text-align: center;
    background-color: #0868FE;
    border: 2px solid #0868FE;
    opacity: 0;
  }
  .animate {
    opacity: 0;
    animation: fadeInOut 3s ease-out;
  }
  @keyframes fadeInOut {
    0% {
      opacity: 0;
    }
    30% {
      opacity: 0.9;
    }
    70% {
      opacity: 0.9;
    }
    100% {
      opacity: 0;
    }
  }`, "",{"version":3,"sources":["webpack://./client/src/layouts/authentication/sign-in/illustration/illustration.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,4CAA4C;IAC5C,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,aAAa;IACb,6CAA6C;IAC7C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,6BAA6B;IAC7B;;cAEU;IACV,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ;kBACc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;IACA;MACE,UAAU;IACZ;EACF","sourcesContent":[".add-customer-pan-verify-i-otp {\n    background-color: rgb(0, 100, 254) !important;\n    color: white !important;\n    font-size: 14px;\n    height: 40px;\n    padding: 0;\n    border-color: white;\n    width: 100%;\n    border-radius: 7px;\n    /* transform: translateY(15px); */\n    float: right;\n    margin-top: 35px !important;\n  }\n  .add-customer-pan-verify-i-scs-otp {\n    background-color: rgb(24, 181, 3) !important;\n    color: white !important;\n    font-size: 14px;\n    height: 40px;\n    padding: 0;\n    width: 100%;\n    border-color: white;\n    border-radius: 7px;\n    /* transform: translateY(15px); */\n    float: right;\n    margin-top: 35px !important;\n  }\n  .add-customer-progress-otp {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: 5px !important;\n    margin-left: 3px !important;\n    color: white !important;\n  }\n  .pallet-img-gif-background {\n    width: 100%;\n    height: 100vh;\n    background-color: rgb(5, 100, 254) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .video-background {\n    z-index: 1;\n    object-fit: contain;\n    width: 50vw;\n    height: 50vh;\n    /* background: rgba(0,0,0,0); */\n    /* opacity: 1; */\n    /* filter: brightness(50%); */\n    /* position: absolute;\n    bottom: 5rem;\n    left: 0; */\n    margin-top: 3rem;\n  }\n  .footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 0;\n    /* position: absolute;\n      bottom: 0; */\n  }\n  .footer-container {\n    padding-top: 15rem;\n  }\n  .message-banner {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    z-index: 100000;\n    width: 100vw;\n    color: #0868FE;\n    font-size: 4em;\n    text-align: center;\n    background-color: #0868FE;\n    border: 2px solid #0868FE;\n    opacity: 0;\n  }\n  .animate {\n    opacity: 0;\n    animation: fadeInOut 3s ease-out;\n  }\n  @keyframes fadeInOut {\n    0% {\n      opacity: 0;\n    }\n    30% {\n      opacity: 0.9;\n    }\n    70% {\n      opacity: 0.9;\n    }\n    100% {\n      opacity: 0;\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
